import { Skeleton, Badge } from '@radix-ui/themes';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { italianDateToJSDate } from 'helpers/utils';
import type { ClubDetailType } from 'types/club';
import type { CompetitionClubType } from 'types/competition';
import type { TournamentType } from 'types/tournament';

export const CompetitionObject: React.FC<
  Partial<CompetitionClubType> & {
    loading?: boolean;
    dates?: string;
    tournaments?: Partial<TournamentType>[];
    club?: Partial<ClubDetailType>;
  }
> = ({ loading, to, from, name, id, dates, club, tournaments }) => {
  const itemClassName = 'p-3 rounded-xl border border-solid border-neutral-neutral-2 hover:bg-accent-accent-3';
  const labelClassName = 'self-stretch text-neutral-neutral-8 text-sm font-medium tracking-normal';
  const contentClassName =
    'flex justify-between gap-2 text-wrap self-stretch text-neutral-neutral-alpha-12 text-base font-bold tracking-tighter';

    const tournamentClassName =
      'bg-neutral-neutral-1 p-3 rounded-xl border border-solid border-neutral-neutral-2 flex flex-row justify-between flex-grow text-neutral-neutral-12 text-xl font-bold tracking-tight';
  const date = new Date();
  const liveBadge =
    date <= italianDateToJSDate(to) && date >= italianDateToJSDate(from) ? (
      <Badge size='1' variant='solid' color='indigo'>
        IN CORSO
      </Badge>
    ) : date < italianDateToJSDate(from) ? (
      <Badge size='1' variant='solid' color='pink'>
        PROGRAMMATA
      </Badge>
    ) : (
      <Badge size='1' variant='solid' color='amber'>
        CONCLUSA
      </Badge>
    );

  return (
    <Link className='w-full' to={`/competizione/${id}`}>
      <div id='competition-scheduled' className={classNames('bg-white', itemClassName)}>
        <Skeleton loading={loading} className='h-auto w-auto'>
          <div id='name' className={contentClassName}>
            {name}
            <div className='flex flex-col items-end gap-2'>
              {to && liveBadge}
              {/* {<Badge size='1' variant='outline'>
                  {rankCategory}
                </Badge>} */}
            </div>
          </div>
        </Skeleton>
        {to && (
          <div id='info' className='flex w-full justify-between pt-2'>
            <Skeleton loading={loading} className='h-auto w-auto'>
              <div id='date' className={labelClassName}>
                {from} - {to}
              </div>
            </Skeleton>
            {/* <Skeleton loading={loading} className='w-auto h-auto'>
            <div id='players' className={labelClassName}>
              {} iscritti
            </div>
          </Skeleton> */}
          </div>
        )}
        {dates && (
          <div id='info' className='flex w-full justify-between pt-2'>
            <Skeleton loading={loading} className='h-auto w-auto'>
              <div id='date' className={labelClassName}>
                {dates}
              </div>
            </Skeleton>
            {club && (
              <Skeleton loading={loading} className='h-auto w-auto'>
                <div id='players' className={labelClassName}>
                  {club.name}
                </div>
              </Skeleton>
            )}

          </div>
        )}
        {tournaments && (
              <Skeleton loading={loading} className='h-auto w-auto'>
                <div className={classNames(labelClassName,'flex flex-col gap-2 pt-2')}>
                  {tournaments.map((tournament) => (
                    <div key={tournament.id} className={tournamentClassName}>
                      <div className='text-sm font-medium'>
                        {tournament.name}
                      </div>
                      <div id='separator' className='mx-1 flex w-px h-10 md:h-4 self-stretch bg-neutral-neutral-4'></div>
                      <div className='text-sm font-bold flex flex-col md:flex-row gap-3'>
                        Iscritti
                      <Badge size='1' variant='solid' className='bg-accent-accent-9 text-white flex justify-center items-center'>
                        {tournament.players_count}
                      </Badge>
                      </div>
                    </div>
                  ))}
                </div>
              </Skeleton>
            )}
      </div>
    </Link>
  );
};

export default CompetitionObject;
